module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-types-potential"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Potentielt ekstra årligt EBITDA pr. opgavetype\n            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.projectTypePotential"
    }
  })], 1), _vm._v(" "), (_vm.projectTypes && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                Her ser du, hvad det giver i øget årligt EBITDA, at øge prisen med få procent.\n            ")]), _vm._v(" "), (_vm.projectTypes.length > 0) ? _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.projectTypes), function(projectType) {
    return _c('div', {
      key: projectType.name,
      staticClass: "single"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('strong', [_vm._v("\n                            " + _vm._s(projectType.name) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_c('b', [_vm._v(_vm._s(projectType.projects_count))]), _vm._v("\n                            opgaver m. samlet omsætning på\n                            "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(projectType.total_revenue)))]), _vm._v(" "), _c('br'), _vm._v("\n                            Gns. DG pr. opgave: "), _c('b', [_vm._v(_vm._s(_vm._f("coveragePercent")(projectType.coverage_percent)) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "slider"
    }, [(projectType.total_revenue > 0) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (projectType.value),
        expression: "projectType.value"
      }],
      attrs: {
        "type": "range",
        "min": -100,
        "max": 100
      },
      domProps: {
        "value": (projectType.value)
      },
      on: {
        "__r": function($event) {
          return _vm.$set(projectType, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "slider-value"
    }, [_c('div', {
      staticClass: "small",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', [_vm._v("\n                                        Meromsætning\n                                    ")]), _vm._v(" "), _c('div', [(projectType.value > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(projectType.value) + " %\n                                    ")])])])]) : _c('div', {
      staticClass: "small",
      attrs: {
        "align": "center"
      }
    }, [_vm._v("\n                            Ingen data for perioden\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "result",
      class: {
        'positive': (projectType.total_revenue / 100) * projectType.value > 0, 'negative': (projectType.total_revenue / 100) * projectType.value < 0
      }
    }, [(projectType.total_revenue > 0 && projectType.value !== 0 && projectType.value !== '0') ? _c('div', [(projectType.value > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(((projectType.total_revenue / 100) * projectType.value * _vm.convertToYear))) + "\n                        ")]) : _c('div', [_vm._v("\n                            -\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "single"
  }, [_c('div', {
    staticClass: "info big"
  }, [_vm._v("\n                        Potentielt ekstra årligt EBITDA\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }), _vm._v(" "), _c('div', {
    staticClass: "result big",
    class: {
      'positive': _vm.total > 0, 'negative': _vm.total < 0
    }
  }, [(_vm.total > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.total)) + "\n                    ")])])], 2) : _vm._e()]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45eaf5ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/potential/components/projectTypesPotential.vue
// module id = 855
// module chunks = 0